import MailIcon from "../images/icons/mail-icon.svg";
import LinkedinIcon from "../images/icons/linkedin-icon.svg";

function Bottombar() {
  return (
    <div
      style={{
        display: "flex",
        position: "absolute",
        left: "0px",
        bottom: "0px",
        width: "100vw",
        height: "200px",
        padding: "0px",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          flexDirection: "row",
          gap: "20px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "12px",
        }}
      >
        <a
          href="https://www.linkedin.com/in/linnea-matilda-olsson"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={LinkedinIcon}
            alt="LinkedIn"
            style={{ cursor: "pointer", height: "25px" }}
          />
        </a>
        <a
          href="mailto:linnea.matilda99@gmail.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={MailIcon}
            alt="Mail Icon"
            style={{ cursor: "pointer", height: "25px" }}
          />
        </a>
      </div>
    </div>
  );
}

export default Bottombar;
